export enum SearchCategoryEnum {
  RESTAURANTS = 'restaurants',
  DISHES = 'dishes',
  EXPERIENCES = 'experiences',
  QINOA = 'home',
  CHEFS = 'chef',
  EVENT = 'blog'
}
